import {doDelete, doGet, doPost} from './http.service'
import {Subscription} from "../types/Subscription";


export function loadSubscriptions() {
    return doGet<Subscription[]>("/subscriptions");
}

export function createSubscription(subscription:Subscription) {
    return doPost<Subscription>("/subscriptions", subscription);
}

export function updateSubscription(id:string, subscription:Subscription) {
    return doPost<Subscription>("/subscriptions/" + id, subscription);
}

export function deleteSubscription(id:string) {
    return doDelete<void>("/public/subscriptions/" + id);

}